// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--kZeLu","link":"_93444fe79c--link--eoxce","link-area":"_93444fe79c--link-area--NQqFo"};